export const getNumberWithOrdinal = number => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const delimeter = number % 100;

  return number + (suffixes[(delimeter - 20) % 10] || suffixes[delimeter] || suffixes[0]);
};
